var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"url-block"},[_c('label',{staticClass:"input-row"},[_c('CustomInput',{attrs:{"pasted":_vm.pasted,"type":"text","name":"text","placeholder":_vm.placeholder,"dis":_vm.isDisabled,"min":_vm.min,"max":_vm.max},on:{"input":_vm.inputPageLink}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }